import {
  Avatar,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Phone, Bolt } from "@mui/icons-material";
import { blue } from "@mui/material/colors";

function ChatDrawer(props: any) {
  const trackingData = props.trackingData;

  const formatDate = (dateStr: any) => {
    const date = new Date(dateStr);
    return date
      .toLocaleString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", ""); // Remove the comma between date and time
  };

  const data = [
    {
      coordinates: "13.07188,77.601281",
      time: "2:09 PM, 04th June, 2024",
      event: "",
    },
    {
      coordinates: "13.07188,77.601281",
      time: "2:09 PM, 04th June, 2024",
      event: "Over Speeding",
    },
    {
      coordinates: "13.07188,77.601281",
      time: "2:09 PM, 04th June, 2024",
      event: "",
    },
    {
      coordinates: "13.07188,77.601281",
      time: "2:09 PM, 04th June, 2024",
      event: "",
    },
    {
      coordinates: "13.07188,77.601281",
      time: "2:09 PM, 04th June, 2024",
      event: "",
    },
  ];

  return (
    <Box>
      {/* User Header */}
      <Box display="flex" alignItems="center" mb={3}>
        <Avatar
          src="https://via.placeholder.com/80"
          sx={{ width: 60, height: 60, marginRight: 2 }}
        />
        <Box>
          <p>{props.name}</p>
          <Box display="flex" alignItems="center" mt={1}>
            <Phone sx={{ color: "orange", fontSize: 16, marginRight: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {props.mobile}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" mt={0.5}>
            <Bolt sx={{ color: "green", fontSize: 16, marginRight: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {props.qrCode}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Timeline */}
      <div style={{ maxHeight: 500, overflowY: "scroll", paddingLeft: 10 }}>
        <List sx={{ borderLeft: "2px solid green", pl: 3 }}>
          {trackingData.map((item: any, index: any) => (
            <ListItem key={index} sx={{ position: "relative" }}>
              {/* Dot */}
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: item.event === "Over Speeding" ? "red" : "green",
                  position: "absolute",
                  left: -30,
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              {/* Content */}
              <ListItemText
                //primary={item.coordinates}
                secondary={
                  <>
                    <Typography variant="body1" color="text.secondary">
                      <a
                        style={{ color: blue[400] }}
                        href={`https://www.google.com/maps?q=${item.latitude.toFixed(
                          6
                        )},${item.longitude.toFixed(6)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.latitude.toFixed(6)},{item.longitude.toFixed(6)}
                      </a>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {formatDate(item.createdTime)}{" "}
                      {/* Format date and time */}
                    </Typography>
                    {item.event && (
                      <Typography
                        variant="body2"
                        color="error"
                        fontWeight="bold"
                      >
                        {item.event}
                      </Typography>
                    )}
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </div>
    </Box>
  );
}

export default ChatDrawer;
